export default "__VITE_ASSET__BKRYUXs4__"